
















































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { NewServiceRequest, ApiRequest, ServiceRequestModel, QueryRecordsRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { CalaculateFareResponse, MemberProfile } from '../../types/response';
import '../../assets/css/RequestConfirmation.scss';
import { ToastEvent } from '../../types/event';
import { EventBus } from '../../main';
import { CommonUtils } from '../../util/commonUtils';
import { DateUtils } from '../../util/dateUtils';
import ChangePaymentModal from '../modal/ChangePaymentModal.vue';
import AddPaymentModal from '../modal/AddPaymentModal.vue';
import SubscriptionModal from '../modal/SubscriptionModal.vue';
import MessageBox from '../../components/MessageBox.vue';
import FareDetails from '../../components/FareDetails.vue';
import { and, required } from 'vuelidate/lib/validators';
import { Route } from '@/types/entity';
@Component({
    props: {
        serviceRequest: Object,
    },
    data() {
        return {
            errormessage: '',
            errorCode: '',
            duplicateRequestNo: '',
            duplicateRequestId: '',
            intervalId: null,
        };
    },
    components: {
        ChangePaymentModal,
        SubscriptionModal,
        AddPaymentModal,
        MessageBox,
        FareDetails,
    },
    validations() {
        const validations = {
            serviceRequest: {
                patient: {
                    primaryHealthInsuranceName: {
                        required,
                    },
                    primaryHealthInsuranceNumber: {
                        required,
                    },
                },
            },
        };
        const serviceRequest = this.$props.serviceRequest;
        if ((serviceRequest.service.type !== 'Transportation') ||
            (serviceRequest.service.type === 'Transportation' &&
                !serviceRequest.transportation.isUsingHealthInsurance)) {
            delete validations.serviceRequest.patient.primaryHealthInsuranceName;
            delete validations.serviceRequest.patient.primaryHealthInsuranceNumber;
        }
        return validations;
    },
})
export default class Confirmation extends Vue {

    private calculatedFare: any = '';
    private showFareDetails = false;
    private finalServiceRequests: NewServiceRequest[] = [];
    private DateUtils = DateUtils;
    private paymentCustomer: any = '';
    private showChangePaymentForm = false;
    private showAddPaymentForm = false;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private paymentCustomerId: string = '';
    private disableFinishButton = false;
    private showSubscriptionPlans = false;
    private subscriptionMessage = '';
    private showSubscriptionConfirmation = false;
    private excludePlan: string | undefined;
    private customerPaymentId = '';
    private estimatedCostEnabled: any = '';
    private messageBoxData = {
        message: CommonUtils.translateMessageCode('MSG_SERVICE_REQUEST'),
        title: 'Success!',
    };
    private blackListedAttoryney = false;
    private showBillToSection = false;
    private billingLocationIds = [] as any;
    private patientPayFallbackRule = null;
    private managersList: MemberProfile[] = [];
    private selectedManagers: MemberProfile[] = [];

    public mounted() {
        this.init();
    }

    private async init() {
        this.$data.errormessage = '';
        this.blackListedAttoryney = false;
        const organizationResponse = await ObjectFactory.getOrganizationService().
        getOrgDetailsById(this.$store.state.serverUrl);
        if (organizationResponse.success && organizationResponse.data) {
           this.estimatedCostEnabled = organizationResponse.data.estimatedCostEnabled;
        }
        this.disableFinishButton = false;
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
        if (this.memberProfile.paymentCustomerId) {
            this.paymentCustomerId = this.memberProfile.paymentCustomerId;
        }
        if (this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER' && this.memberProfile.memberPaymentCustomerId) {
            this.paymentCustomerId = this.memberProfile.memberPaymentCustomerId;
        }
        const serviceRequestModel: ServiceRequestModel = JSON.parse(JSON.stringify(this.$props.serviceRequest));
        if (this.memberProfile.isApprovalRequired) {
            this.onBillingOptionChange();
        }
        if (serviceRequestModel.transportation && serviceRequestModel.patient.patientWeight === '' as any) {
                delete serviceRequestModel.patient.patientWeight;
        }
        if (!serviceRequestModel.stops.isStop3Valid) {
            this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING });
            return;
        }
        this.finalServiceRequests = [];
        if (!serviceRequestModel.multipleAppointment && serviceRequestModel.appointments.length > 1) {
            serviceRequestModel.appointments = serviceRequestModel.appointments.slice(0, 1);
        }
        serviceRequestModel.appointments.forEach((appointment) => {
            if (serviceRequestModel.service.type === 'Transportation' && serviceRequestModel.transportation &&
                serviceRequestModel.transportation.isImmediateTransportation) {
                appointment.date = DateUtils.formatDate(DateUtils.getCurrentUTCTimeInMillis(),
                    'YYYY-MM-DD', appointment.timezone);
                appointment.time = DateUtils.formatDate(DateUtils.getCurrentUTCTimeInMillis()
                    + DateUtils.convertMinutesToMillis(10), 'HH:mm', appointment.timezone);
                this.updateAppointmentTime();
                this.$data.intervalId = setInterval(() => {
                    this.updateAppointmentTime();
                }, 60000);
            }
            const finalServiceRequest: NewServiceRequest = {
                appointment: {
                    appointmentDate: appointment.date,
                    appointmentTime: appointment.time,
                    coordinator: serviceRequestModel.coordinator,
                    facility: serviceRequestModel.facility,
                    patient: serviceRequestModel.patient,
                    timezone: appointment.timezone,
                },
                billingLocation: serviceRequestModel.billingLocationId,
                additionalNotes: serviceRequestModel.additionalNotes,
                rxAdditionalNotes: serviceRequestModel.rxAdditionalNotes,
                additionalContacts: serviceRequestModel.additionalContacts,
            };
            if (finalServiceRequest.billingLocation) {
                this.billingLocationIds.push(finalServiceRequest.billingLocation);
            }
            if (finalServiceRequest.appointment) {
                delete finalServiceRequest.appointment.patient.firstName;
                delete finalServiceRequest.appointment.patient.lastName;
            }
            if (serviceRequestModel.additionalContacts && serviceRequestModel.additionalContacts.length) {
                serviceRequestModel.additionalContacts.map((contact: any) => {
                    if (!contact.isSMS) {
                        contact.phone = '';
                    }
                    if (!contact.isEmail) {
                        contact.email = '';
                    }
                    return contact;
                });
            }
            if (serviceRequestModel.service.type !== 'Transportation') {
                delete finalServiceRequest.additionalContacts;
            }
            if ((!serviceRequestModel.transportation ||
                !serviceRequestModel.transportation.isUsingHealthInsurance) && finalServiceRequest.appointment) {
                delete finalServiceRequest.appointment.patient.primaryHealthInsuranceName;
                delete finalServiceRequest.appointment.patient.primaryHealthInsuranceNumber;
                delete finalServiceRequest.appointment.patient.secondaryHealthInsuranceNumber;
                delete finalServiceRequest.appointment.patient.secondaryHealthInsuranceName;
                delete finalServiceRequest.appointment.patient.customerServiceNumber;
            }
            if (serviceRequestModel.service.type !== 'Transportation' && finalServiceRequest.appointment) {
                delete finalServiceRequest.appointment.patient.patientHeight;
                delete finalServiceRequest.appointment.patient.patientWeight;
            }

            if ((serviceRequestModel.interpretation &&
                (serviceRequestModel.service.type === 'Interpretation' || serviceRequestModel.service.type === 'TransInterpreter'))
                || (serviceRequestModel.telemedicine && serviceRequestModel.telemedicine.interpreterRequired)) {
                finalServiceRequest.interpreterRequest = serviceRequestModel.interpretation;
                if (serviceRequestModel.service.type === 'Interpretation') {
                    delete finalServiceRequest.homeAssistanceRequest;
                }
            }
            if (serviceRequestModel.transportation && serviceRequestModel.transportation.homeAssistance &&
                !finalServiceRequest.interpreterRequest) {
                finalServiceRequest.homeAssistanceRequest = serviceRequestModel.homeAssistance;
                if (serviceRequestModel.sameAsTransportAddress && finalServiceRequest.homeAssistanceRequest) {
                    finalServiceRequest.homeAssistanceRequest.address = serviceRequestModel.pickupAddress;
                }
                if (serviceRequestModel.followTransportRequest && finalServiceRequest.homeAssistanceRequest &&
                    finalServiceRequest.appointment) {
                    finalServiceRequest.homeAssistanceRequest.appointmentDate =
                        finalServiceRequest.appointment.appointmentDate;
                    finalServiceRequest.homeAssistanceRequest.appointmentTime =
                        finalServiceRequest.appointment.appointmentTime;
                }
            }
            if (serviceRequestModel.transportation &&
                (serviceRequestModel.service.type === 'Transportation' || serviceRequestModel.service.type === 'TransInterpreter')) {
                let transport = serviceRequestModel.transportation.vehicleType as string;
                if (serviceRequestModel.transportation.vehicleType === 'Sedan') {
                    if (serviceRequestModel.transportation.visitType === 'Procedure') {
                        transport = 'Ambulatory (Procedure)';
                    } else {
                        transport = 'Ambulatory (Non-Procedure)';
                    }
                }
                finalServiceRequest.transportRequest = {
                    visitType: serviceRequestModel.transportation.visitType,
                    caregiver: serviceRequestModel.transportation.caregiver !== undefined ?
                        serviceRequestModel.transportation.caregiver : false,
                    rideshareService: true,
                    conciergeService: serviceRequestModel.transportation.conciergeService,
                    mentalHealth: serviceRequestModel.transportation.mentalHealth,
                    isBariatricServiceRequired: serviceRequestModel.transportation.isBariatricServiceRequired
                        === 'Yes' ? true : false,
                    isImmediateRequest: serviceRequestModel.transportation.isImmediateTransportation,
                    isWheelchairProvided: serviceRequestModel.transportation.isWheelchairProvided
                        === 'Yes' ? true : false,
                    isOxygenTankRequired: serviceRequestModel.transportation.isOxygenTankRequired,
                    isUsingHealthInsurance: serviceRequestModel.transportation.isUsingHealthInsurance,
                    vehicleType: serviceRequestModel.transportation.vehicleType,
                    driverGenderPreference: serviceRequestModel.transportation.driverGenderPreference,
                    routes: [
                        {
                            pickupAddress: serviceRequestModel.pickupAddress,
                            dropoffAddress: serviceRequestModel.dropoffAddress,
                        },
                    ],
                    transport,
                    estimatedVisitTime: serviceRequestModel.transportation.estimatedVisitTime,
                    providedWheelchairOption: serviceRequestModel.transportation.providedWheelchairOption,
                    additionalPassengers: serviceRequestModel.transportation.additionalPassengers,
                    timescope: serviceRequestModel.transportation.timescope,
                    hasCovidSymptoms: serviceRequestModel.transportation.hasCovidSymptoms,
                };
                if (serviceRequestModel.transportation.additionalPassengers &&
                    serviceRequestModel.transportation.additionalPassengers > 1) {
                    finalServiceRequest.transportRequest.additionalPatients =
                        serviceRequestModel.transportation.additionalPatients;
                }
                if (serviceRequestModel.roundTrip && serviceRequestModel.transportation.conciergeService) {
                    finalServiceRequest.transportRequest.rideshareService = false;
                }
                if (serviceRequestModel.transportation.vehicleType === 'BLS') {
                    finalServiceRequest.transportRequest.blsServiceOptions
                        = serviceRequestModel.transportation.blsServiceOptions;
                    if (serviceRequestModel.transportation.blsOtherResponse &&
                        finalServiceRequest.transportRequest.blsServiceOptions
                        && !finalServiceRequest.transportRequest.blsServiceOptions.
                            includes(serviceRequestModel.transportation.blsOtherResponse)) {
                        finalServiceRequest.transportRequest.blsServiceOptions.push(
                            serviceRequestModel.transportation.blsOtherResponse);
                    }
                }
                if (serviceRequestModel.transportation.vehicleType === 'Sedan') {
                    if (serviceRequestModel.transportation.visitType === 'Procedure'
                        || serviceRequestModel.transportation.isOxygenTankRequired
                        || serviceRequestModel.transportation.mentalHealth
                    ) {
                        finalServiceRequest.transportRequest.rideshareService = false;
                    }
                } else {
                    finalServiceRequest.transportRequest.rideshareService = false;
                }
                if (finalServiceRequest.transportRequest.rideshareService
                    || finalServiceRequest.transportRequest.conciergeService === undefined) {
                    finalServiceRequest.transportRequest.conciergeService = false;
                }

                if (serviceRequestModel.transportation && serviceRequestModel.transportation.attorneyEmail) {
                    const transportRequest = finalServiceRequest.transportRequest;
                    transportRequest.attorneyName = serviceRequestModel.transportation.attorneyName;
                    transportRequest.attorneyEmail = serviceRequestModel.transportation.attorneyEmail;
                    transportRequest.attorneyFirmName = serviceRequestModel.transportation.attorneyFirmName;
                    transportRequest.attorneyPhoneNo = serviceRequestModel.transportation.attorneyPhoneNo;
                }
                if (serviceRequestModel.roundTrip) {
                    finalServiceRequest.transportRequest.routes.push(
                        {
                            dropoffAddress: serviceRequestModel.pickupAddress,
                            pickupAddress: serviceRequestModel.dropoffAddress,
                        });
                }
            }

            if (serviceRequestModel.transportation && serviceRequestModel.transportation.hasRxStop &&
                    serviceRequestModel.transportation.rxStop && finalServiceRequest.transportRequest) {
                    const routeLength = finalServiceRequest.transportRequest.routes.length;
                    finalServiceRequest.transportRequest.routes[routeLength - 1].additionalStops = [{
                        address: serviceRequestModel.transportation.rxStop.rxAddress,
                        isRxStop: true,
                        name: serviceRequestModel.transportation.rxStop.rxStopName,
                    }];
                }

            if (serviceRequestModel.telemedicine && serviceRequestModel.service.type === 'Telemedicine') {
                finalServiceRequest.telemedicineRequest = {
                    description: serviceRequestModel.telemedicine.description,
                    participants: serviceRequestModel.telemedicine.participants,
                };
            }

            if (serviceRequestModel.homeHealthCare && serviceRequestModel.patient.address
                && serviceRequestModel.service.type === 'HomeHealthCare') {
                finalServiceRequest.homeHealthCareRequest = {
                    address: serviceRequestModel.patient.address,
                    estimatedVisitTime: serviceRequestModel.homeHealthCare.estimatedVisitTime,
                    serviceType: serviceRequestModel.homeHealthCare.serviceType,
                };
            }

            if (serviceRequestModel.delivery && serviceRequestModel.patient.address &&
                !serviceRequestModel.delivery.isCmr &&
                serviceRequestModel.service.type === 'Delivery') {
                finalServiceRequest.deliveryRequest = {
                    routes: [{
                        pickupAddress: serviceRequestModel.pickupAddress,
                        dropoffAddress: serviceRequestModel.dropoffAddress,
                    }],
                    businessCloseTime: serviceRequestModel.delivery.businessCloseTime,
                    deliveryItems: serviceRequestModel.delivery.deliveryItems,
                    confirmationMode: serviceRequestModel.delivery.confirmationMode,
                    additionalIdentifiers: serviceRequestModel.delivery.additionalIdentifiers,
                };
                if (serviceRequestModel.service.type === 'Delivery') {
                    delete finalServiceRequest.homeAssistanceRequest;
                }
            }
            if (serviceRequestModel.delivery && serviceRequestModel.delivery.isCmr && serviceRequestModel.cmr) {
                finalServiceRequest.cmrRequest = {
                    healthInsuranceName: serviceRequestModel.cmr.healthInsuranceName,
                    patientSecPhone: serviceRequestModel.cmr.patientSecPhone ?
                        serviceRequestModel.cmr.patientSecPhone : '',
                };
                delete finalServiceRequest.homeAssistanceRequest;
            }
            if (serviceRequestModel.interpretation && finalServiceRequest.appointment &&
                !finalServiceRequest.transportRequest && !finalServiceRequest.deliveryRequest &&
                !finalServiceRequest.cmrRequest && !finalServiceRequest.homeHealthCareRequest) {
                delete finalServiceRequest.appointment.patient.address;
            }
            if (serviceRequestModel.preferredProviderRequired && serviceRequestModel.preferredProvider
             && (serviceRequestModel.service.type === 'Transportation' || serviceRequestModel.service.type === 'Interpretation')) {
                finalServiceRequest.preferredProviderId = serviceRequestModel.preferredProvider.providerId;
            }
            if (serviceRequestModel.rxAdditionalNotes) {
                finalServiceRequest.rxAdditionalNotes = serviceRequestModel.rxAdditionalNotes;
            }
            if (serviceRequestModel.transportation && serviceRequestModel.transportation.hasRxStop
            && serviceRequestModel.rxAdditionalNotes) {
                finalServiceRequest.rxAdditionalNotes = serviceRequestModel.rxAdditionalNotes;
            } else {
                delete finalServiceRequest.rxAdditionalNotes;
            }
            this.finalServiceRequests.push(finalServiceRequest);
            });
        if (this.memberProfile.memberType !== 'ORG_CUSTOMER' && this.estimatedCostEnabled ) {
            const iHttpService = ObjectFactory.getHttpService();
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_REQUEST}/fare`,
                data: this.finalServiceRequests,
                loaderEvent: {
                    message: CommonUtils.translateMessageCode('MSG_CALCULATE_FARE'),
                    show: true,
                },
            };
            const response = await iHttpService.post<CalaculateFareResponse>(apiRequest);
            if (response.success && response.data) {
                this.calculatedFare = response.data;
            } else {
                if (response.errorCode) {
                    const errorMessage = CommonUtils.translateErrorCode(response.errorCode);
                    if (errorMessage) {
                        this.$data.errormessage = `An error has occurred! Share this error with your Customer Success representative:${errorMessage}`;
                    } else if (response.errors) {
                        this.$data.errormessage = `An error has occurred! Share this error with your Customer Success representative:${response.errors[0]}`;
                    }
                }
            }
        } else {
            this.calculatedFare = true;
        }
        const organization = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organization.data &&
            (!organization.data.chequePaymentRequest
                || organization.data.chequePaymentRequest.status !== 'Approved'
                || this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER')) {
            this.getPaymentCustomer();
        }
        if (serviceRequestModel .transportation && !serviceRequestModel.transportation.isImmediateTransportation
            && organization.data && !organization.data.lienCustomerEnabled &&
            !organization.data.reimbursementRateDetails && organization.data.patientPayEnabled) {
            this.showBillToSection = true;
            if (organization.data.patientPayFallbackRule) {
                this.patientPayFallbackRule = organization.data.patientPayFallbackRule as any;
            }
        }
        if (!this.showBillToSection) {
            this.$props.serviceRequest.isPatientPaySelected = false;
            this.$props.serviceRequest.managerIds = null;
        }
        await this.checkBlacklistedAttorney();
    }

    private async getPaymentCustomer() {
        const memberResponse = await ObjectFactory.getMemberService().
                    getMemberDetails(this.$store.state.serverUrl, this.memberProfile.memberId);
        if (!this.customerPaymentId && this.blackListedAttoryney) {
            if (memberResponse.success && memberResponse.data && memberResponse.data.memberPaymentCustomerId) {
                this.customerPaymentId = memberResponse.data.memberPaymentCustomerId;
                this.paymentCustomerId = memberResponse.data.memberPaymentCustomerId;
            } else {
                this.paymentCustomer = '';
                return;
            }
        } else if (memberResponse.data && memberResponse.data.memberType === 'ORG_LIEN_CUSTOMER'
            && memberResponse.data.memberPaymentCustomerId) {
            this.customerPaymentId = memberResponse.data.memberPaymentCustomerId;
            this.paymentCustomerId = memberResponse.data.memberPaymentCustomerId;
        }
        const response = await ObjectFactory.getPaymentSourceService()
            .getPaymentCustomer(this.$store.state.serverUrl, this.customerPaymentId);
        this.paymentCustomer = response.data;
    }

    private async submitRequest() {
        this.disableFinishButton = true;
        clearInterval(this.$data.intervalId);
        const iHttpService = ObjectFactory.getHttpService();
        const serviceRequestModel: ServiceRequestModel = this.$props.serviceRequest;
        this.finalServiceRequests.forEach((request) => {
            if (serviceRequestModel.transportation && !serviceRequestModel.roundTrip && request.transportRequest) {
                request.transportRequest.estimatedVisitTime = {
                    hours: 0,
                    minutes: 0,
                };
            }
            if (serviceRequestModel.transportation && request.transportRequest ) {
                request.transportRequest.driverGenderPreference =
                serviceRequestModel.transportation.driverGenderPreference;
                request.transportRequest.routes.forEach((route: Route) => {
                    delete route.pickupAddress.pickupInstructionImageUrl;
                    delete route.dropoffAddress.dropoffInstructionImageUrl;
                });
            }
            if (serviceRequestModel.transportation && serviceRequestModel.transportation.isUsingHealthInsurance) {
                if (request.appointment) {
                    const patient = request.appointment.patient;
                    patient.primaryHealthInsuranceName = serviceRequestModel.patient.primaryHealthInsuranceName;
                    patient.primaryHealthInsuranceNumber = serviceRequestModel.patient.primaryHealthInsuranceNumber;
                    patient.secondaryHealthInsuranceName = serviceRequestModel.patient.secondaryHealthInsuranceName;
                    patient.secondaryHealthInsuranceNumber = serviceRequestModel.patient.secondaryHealthInsuranceNumber;
                    patient.customerServiceNumber = serviceRequestModel.patient.customerServiceNumber;
                    patient.preferredLanguage = serviceRequestModel.patient.preferredLanguage;
                }
                if (request.transportRequest) {
                    request.transportRequest.isUsingHealthInsurance = true;
                }
            } else {
                if (request.transportRequest) {
                    request.transportRequest.isUsingHealthInsurance = false;
                }
                if (request.appointment) {
                    const patient = request.appointment.patient;
                    delete patient.primaryHealthInsuranceName;
                    delete patient.primaryHealthInsuranceNumber;
                    delete patient.secondaryHealthInsuranceName;
                    delete patient.secondaryHealthInsuranceNumber;
                    delete patient.customerServiceNumber;
                }
            }
            if (request.transportRequest && request.transportRequest.vehicleType === 'Sedan' && request.appointment) {
                delete request.appointment.patient.patientHeight;
                delete request.appointment.patient.patientWeight;
            }
            if (request.transportRequest && (request.transportRequest.vehicleType === 'Sedan' ||
                request.transportRequest.vehicleType === 'Stretcher')) {
                delete request.transportRequest.providedWheelchairOption;
            }
            if (!request.transportRequest || request.deliveryRequest) {
                delete request.isPatientPaySelected;
                delete request.managerIds;
            } else {
                request.isPatientPaySelected = serviceRequestModel.isPatientPaySelected;
                if (this.memberProfile.isApprovalRequired) {
                    request.managerIds = this.selectedManagers.map((manager) => manager.memberId);
                }
            }
        });
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}`,
            data: this.finalServiceRequests,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<string[]>(apiRequest);
        if (response.success && response.data) {
            const sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
            if (!sessionInfo.scopes.includes('member') && (sessionInfo.scopes.includes('admin')
                 || sessionInfo.scopes.includes('operation'))) {
                const messageBox: any = this.$refs.messageBox;
                messageBox.showModal();
            } else {
                const toastEvent: ToastEvent = {
                    message: CommonUtils.translateMessageCode('MSG_SERVICE_REQUEST'),
                    title: 'Success!',
                    timeout: 5000,
                    varient: 'success',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                let requestType = 'interpreterRequest';
                if (this.finalServiceRequests[0] && this.finalServiceRequests[0].transportRequest) {
                    requestType = 'transportRequest';
                } else if (this.finalServiceRequests[0] && this.finalServiceRequests[0].telemedicineRequest) {
                    requestType = 'telemedicineRequest';
                } else if (this.finalServiceRequests[0] && this.finalServiceRequests[0].deliveryRequest) {
                    requestType = 'deliveryRequest';
                } else if (this.finalServiceRequests[0] && this.finalServiceRequests[0].cmrRequest) {
                    requestType = 'cmrRequest';
                } else if (this.finalServiceRequests[0] && this.finalServiceRequests[0].homeHealthCareRequest) {
                    requestType = 'homeHealthCareRequest';
                }
                this.$router.push({
                    path: `${MedTransGoConstants.URL_REQUESTS}/${response.data[0]}`,
                    query: { requestType },
                });
            }

        } else {
            this.disableFinishButton = false;
            if (response.errorCode === 'NO_SUBSCRIPTION_PLAN_FOUND') {
                this.showSubscriptionConfirmation = true;
                this.excludePlan = '';
                this.subscriptionMessage = 'We are unable to submit your request as your account has no subscription plan activated. Please click on \'Proceed\' to choose a subscription plan.';
            } else if (response.errorCode === 'SUBSCRIPTION_PLAN_LIMIT_EXCEEDED') {
                this.showSubscriptionConfirmation = true;
                this.excludePlan = 'FREE';
                this.subscriptionMessage = 'Your subscription plan request limit exceeded. Please click on \'Proceed\' to upgrade your subscription plan.';
            }
            if (response.errors) {
                const errorMessage = CommonUtils.translateErrorCode(response.errorCode);
                this.$data.errormessage = errorMessage || response.errors[0];
                this.$data.errorCode = response.errorCode;
                if (response.errorCode === 'DUPLICATE_REQUEST') {
                    this.$data.duplicateRequestNo = response.errors[1];
                    this.$data.duplicateRequestId = response.errors[2];
                }
            }
        }
    }

    private preStep() {
        this.$router.go(-1);
    }

    private validateDate() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.patient.birthdate) {
            const birthdate = new Date(serviceRequest.patient.birthdate);
            const today = new Date();
            if (birthdate > today) {
                serviceRequest.patient.birthdate = '';
            }
        }
    }

    private showSubscriptionModal() {
        this.showSubscriptionConfirmation = false;
        this.showSubscriptionPlans = true;
    }

    private async activateSubscriptionPlan(plan: string) {
        this.showSubscriptionPlans = false;
        ObjectFactory.getSubscriptionService().activateSubscriptionPlan(plan, this.$store.state.serverUrl);
    }

    private closeWindow() {
        ObjectFactory.getCacheService().clearCache();
        close();
    }

    private async checkBlacklistedAttorney() {
        const serviceRequestModel: ServiceRequestModel = this.$props.serviceRequest;
        if (this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER' && serviceRequestModel.transportation &&
            serviceRequestModel.transportation.attorneyFirmName) {
            const queryRecordsRequest: QueryRecordsRequest = {
                conditions: [{
                    fieldName: 'firmName',
                    op: 'regex',
                    value: `^${serviceRequestModel.transportation.attorneyFirmName}$`,
                },
                {
                    conditions: [
                    {
                        fieldName: 'status',
                        op: 'ne',
                        value: 'ACTIVE',
                    },
                    {
                        fieldName: 'status',
                        op: 'eq',
                        value: null,
                    }],
                    op: 'or',
                }],
                limit: MedTransGoConstants.PAGINATION_LIMIT,
                start: 0,
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                data: queryRecordsRequest,
                url: `${MedTransGoConstants.HTTP_URL_ATTORNEY}/list`,
                loaderEvent: {
                    show: true,
                },
            };
            const iHttpService = ObjectFactory.getHttpService();
            const response = await iHttpService.post<any>(apiRequest);
            if (response.success && response.data && response.data.length) {
                this.blackListedAttoryney = true;
                this.getPaymentCustomer();
            }
        }
    }

    private async openDuplicateRequestLink() {
        const path = `/requests/${this.$data.duplicateRequestId}`;
        const query = this.$route.query as Record<string, string> || {};
        const fullPath = `${path}?${new URLSearchParams(query).toString()}`;
        window.open(fullPath, '_blank');
    }

    private updateAppointmentTime() {
        this.$props.serviceRequest.appointments.forEach((appointment: any) => {
            if (this.$props.serviceRequest.service.type === 'Transportation'
                && this.$props.serviceRequest.transportation &&
                this.$props.serviceRequest.transportation.isImmediateTransportation) {
                    appointment.date = DateUtils.formatDate(DateUtils.getCurrentUTCTimeInMillis(),
                        'YYYY-MM-DD', appointment.timezone);
                    appointment.time = DateUtils.formatDate(DateUtils.getCurrentUTCTimeInMillis()
                        + DateUtils.convertMinutesToMillis(10), 'HH:mm', appointment.timezone);
            }
        });
    }

    private onBillingOptionChange() {
        if (this.memberProfile.isApprovalRequired
            && (!this.patientPayFallbackRule || this.patientPayFallbackRule !== 'AUTO_CANCEL'
                || !this.$props.serviceRequest.isPatientPaySelected)) {
            this.getManagersList();
        }

    }

    private async getManagersList() {
        const iHttpService = ObjectFactory.getHttpService();
        const organizationId = this.memberProfile.organization && this.memberProfile.organization.id
            ? this.memberProfile.organization.id : '';
        const queryRecordsRequest: QueryRecordsRequest = {
            limit: 1000,
            start: 0,
            conditions: [{
                op: 'eq',
                fieldName: 'organizationId',
                value: organizationId,
            },
            {
                conditions: [{
                    conditions: [{
                        op: 'eq',
                        fieldName: 'memberType',
                        value: 'ORG_MANAGER',
                    },
                    {
                        op: 'eq',
                        fieldName : 'locationId',
                        value: this.$props.serviceRequest.billingLocationId,
                    }],
                    op: 'and',
                },
                {
                    op: 'eq',
                    fieldName: 'memberType',
                    value: 'ORG_ADMIN',
                }],
                op: 'or',
            }],
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_MEMBERS}/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<MemberProfile[]>(apiRequest);
        if (response.success && response.data) {
            this.managersList = response.data;
        }
    }
}
